import { useEffect } from "react";

export default function useUnsavedChanges(condition = false) {
  useEffect(() => {
    const beforeUnloadHandler = (event) => {
      if (condition) {
        event.preventDefault();
        event.returnValue = true; // This is required for Chrome
      }
    };

    const popStateHandler = (event) => {
      if (condition) {
        const confirmLeave = window.confirm(
          "You have unsaved changes. Are you sure you want to leave?"
        );
        if (!confirmLeave) {
          // Push the current state back to the history stack
          window.history.pushState(null, "", window.location.pathname);
        }
      }
    };

    window.addEventListener("beforeunload", beforeUnloadHandler);
    window.addEventListener("popstate", popStateHandler);

    return () => {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
      window.removeEventListener("popstate", popStateHandler);
    };
  }, [condition]);
}
